export default __webpack_public_path__ + "BetConstruct-Icons-95573c81.ttf";